import api from "../helpers/axios";
import { WebPubSubClient } from "@azure/web-pubsub-client";

let pubsubClient = null;

export function initLogoutListener(sessionId, setShowForcedLogout) {
    if (pubsubClient) {
        return pubsubClient.stop;
    }

    pubsubClient = new WebPubSubClient({
        getClientAccessUrl: async () => {
            const res = await api.get('/misc/pubsub/token');
            const { url } = res?.data;
            return url;
        },
    });

    pubsubClient.on("connected", () => {
        console.log("Connected to Azure PubSub");
        pubsubClient.joinGroup(sessionId);
    });

    pubsubClient.on("group-message", (msg) => {
        const data = msg.message.data;

        console.log(
            "Forced logout message received:",
            data,
            sessionId,
            data.type === "FORCED_LOGOUT",
            data.session_id === sessionId,
            data.type === "FORCED_LOGOUT" && data.session_id === sessionId
        );

        if (data.type === "FORCED_LOGOUT" && data.session_id === sessionId) {
            setShowForcedLogout(true);
        }
    });

    pubsubClient.start().catch((err) => {
        console.error("WebPubSub connection error: ", err);
    });

    return () => {
        console.log("Stopping PubSub client");
        pubsubClient?.stop();
        pubsubClient = null;
    };
}

export function disconnectLogoutListener() {
    if (pubsubClient) {
        console.log("Disconnecting WebPubSub");
        pubsubClient.stop();
        pubsubClient = null;
    }
}
